import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useRegisterStore} from "@domains/auth/stores/register.store";
import {type SignUpNs} from "@shared/types";
import {toast} from '@shared/ms-components'

export const confirmEmailResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    const payload = {
        activationCode: to.query.ac,
        userId: to.query.un,
    } as SignUpNs.ActivateAccountRequest;

    const isAuthPage = window.location.href.indexOf('/auth/') > -1;
    const registerStore = useRegisterStore();
    registerStore.confirmPrimaryEmail(payload).then(() => {
        toast.success('Email address has been changed');

        next({path: '/auth/sign-in'});
    }).catch(() => {
        next({path: '/auth/sign-in'});
    })

};
